(() => {
  const normalize = (value) => value.toLowerCase().trim();

  const createSuggestionMarkup = (matches, activeIndex) =>
    matches
      .map(
        (match, index) => `
          <a
            class="b-anleitungen__search-result"
            href="${match.href}"
            role="option"
            aria-selected="${index === activeIndex ? 'true' : 'false'}"
            data-anleitungen-search-result
            data-anleitungen-search-index="${index}"
          >
            <span class="b-anleitungen__search-result-label">${match.title}</span>
            <span class="b-anleitungen__search-result-arrow" aria-hidden="true">&#8594;</span>
          </a>
        `
      )
      .join('');

  const initFilterRoot = (root) => {
    const forms = Array.from(root.querySelectorAll('[data-anleitungen-search]'));
    const inputs = forms
      .map((form) => form.querySelector('[data-anleitungen-search-input]'))
      .filter(Boolean);

    if (inputs.length === 0) return;

    const items = Array.from(root.querySelectorAll('[data-anleitungen-filter-item]'));
    const groups = Array.from(root.querySelectorAll('[data-anleitungen-filter-group]'));
    const filterLists = Array.from(root.querySelectorAll('[data-anleitungen-filter-list]'));
    const resultsPanels = Array.from(root.querySelectorAll('[data-anleitungen-search-results]'));
    const emptyState = root.querySelector('[data-anleitungen-filter-empty]');

    const suggestions = items
      .filter((item) => item.tagName === 'A' && item.href)
      .map((item) => ({
        title: (item.getAttribute('data-anleitungen-title') || item.textContent || '').trim(),
        text: normalize(item.getAttribute('data-anleitungen-filter-text') || item.textContent || ''),
        href: item.href,
      }))
      .filter((entry) => entry.title !== '');

    let currentMatches = [];
    let activeSuggestionIndex = -1;

    const closeSuggestions = () => {
      currentMatches = [];
      activeSuggestionIndex = -1;

      resultsPanels.forEach((panel) => {
        panel.hidden = true;
        panel.innerHTML = '';
      });

      inputs.forEach((input) => input.setAttribute('aria-expanded', 'false'));
    };

    const renderSuggestions = () => {
      const hasSuggestions = currentMatches.length > 0;

      resultsPanels.forEach((panel) => {
        panel.hidden = !hasSuggestions;
        panel.innerHTML = hasSuggestions ? createSuggestionMarkup(currentMatches, activeSuggestionIndex) : '';
      });

      inputs.forEach((input) => input.setAttribute('aria-expanded', hasSuggestions ? 'true' : 'false'));
    };

    const applyFilter = (rawValue) => {
      const query = normalize(rawValue);
      let visibleCount = 0;

      items.forEach((item) => {
        const haystack = normalize(item.getAttribute('data-anleitungen-filter-text') || item.textContent || '');
        const isVisible = query === '' || haystack.includes(query);

        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      groups.forEach((group) => {
        const hasVisibleItems = Array.from(group.querySelectorAll('[data-anleitungen-filter-item]')).some(
          (item) => !item.hidden
        );
        group.hidden = !hasVisibleItems;
      });

      filterLists.forEach((list) => {
        const hasVisibleItems = Array.from(list.querySelectorAll('[data-anleitungen-filter-item]')).some(
          (item) => !item.hidden
        );
        list.hidden = !hasVisibleItems;
      });

      if (emptyState) {
        // Only show the "no match" notice during an active search, not when the
        // page simply has no Anleitungen (that case has its own empty state).
        emptyState.hidden = query === '' || visibleCount > 0;
      }

      if (query === '' || suggestions.length === 0) {
        closeSuggestions();
        return;
      }

      currentMatches = suggestions.filter((entry) => entry.text.includes(query)).slice(0, 6);
      activeSuggestionIndex = currentMatches.length > 0 ? 0 : -1;
      renderSuggestions();
    };

    const syncInputs = (value, sourceInput) => {
      inputs.forEach((otherInput) => {
        if (otherInput !== sourceInput) {
          otherInput.value = value;
        }
      });
    };

    forms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (activeSuggestionIndex >= 0 && currentMatches[activeSuggestionIndex]) {
          window.location.href = currentMatches[activeSuggestionIndex].href;
        }
      });
    });

    inputs.forEach((input) => {
      const syncAndFilter = (event) => {
        const value = event.currentTarget.value;
        syncInputs(value, event.currentTarget);
        applyFilter(value);
      };

      input.addEventListener('input', syncAndFilter);
      input.addEventListener('search', syncAndFilter);
      input.addEventListener('focus', () => {
        if (input.value.trim() !== '') {
          applyFilter(input.value);
        }
      });

      input.addEventListener('keydown', (event) => {
        if (currentMatches.length === 0) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeSuggestionIndex = Math.min(activeSuggestionIndex + 1, currentMatches.length - 1);
          renderSuggestions();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeSuggestionIndex = Math.max(activeSuggestionIndex - 1, 0);
          renderSuggestions();
        } else if (event.key === 'Escape') {
          closeSuggestions();
        } else if (event.key === 'Enter' && activeSuggestionIndex >= 0) {
          event.preventDefault();
          window.location.href = currentMatches[activeSuggestionIndex].href;
        }
      });
    });

    root.addEventListener('click', (event) => {
      const result = event.target.closest('[data-anleitungen-search-result]');
      if (result) return;

      if (!event.target.closest('[data-anleitungen-search]') && !event.target.closest('[data-anleitungen-search-results]')) {
        closeSuggestions();
      }
    });

    resultsPanels.forEach((panel) => {
      panel.addEventListener('click', (event) => {
        const result = event.target.closest('[data-anleitungen-search-result]');
        if (!result) return;

        const index = Number(result.getAttribute('data-anleitungen-search-index'));
        if (!Number.isNaN(index)) {
          activeSuggestionIndex = index;
          renderSuggestions();
        }
      });
    });

    applyFilter(inputs[0].value || '');
  };

  const init = () => {
    document.querySelectorAll('[data-anleitungen-filter-root]').forEach(initFilterRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
